module.exports = new __parcel__URL__("menacingblow.faa64946.png").toString();